import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { environment } from 'src/environments/environment';
import { HttpHelperService } from '../http.service';
import { ApplicationVersion } from 'src/app/types/dto/application-version.dto';
import { AreaPermission } from 'src/app/types/dto/area-permission.dto';
import { CompanyDto } from 'src/app/types/dto/company.dto';
import { UserTokenCheck } from 'src/app/types/dto/user-token-check';
import { tap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class AuthApiService {
  private http = inject(HttpClient);
  private httpHelper = inject(HttpHelperService);


  authorisedCompanies?: CompanyDto[];

  appBaseURL = environment.apiUrl + 'applications/';

  getCurrentApplicationVersion(): Observable<ApplicationVersion> {
    const url = this.appBaseURL + environment.appId + 'latest-version';
    return this.http.get<ApplicationVersion>(url, this.httpHelper.httpReadOnlyOptions);
  }

  getAreaPermissions(): Observable<AreaPermission[]> {
    const appId = '7' // this is unused by API!
    const url = this.appBaseURL + appId + '/area-permissions/me';
    return this.http.get<AreaPermission[]>(url, this.httpHelper.httpReadOnlyOptions);
  }

  getAuthorisedCompanies(email: string): Observable<CompanyDto[]> {
    const url = environment.apiUrl + 'email-addresses/' + email.replace('@', '%40')
        + '/authorised-companies';

    if (this.authorisedCompanies) {
      return of(this.authorisedCompanies);
    } else {
      return this.http.get<CompanyDto[]>(url, this.httpHelper.httpReadOnlyOptions)
        .pipe(tap(comps => this.authorisedCompanies = comps));
    }
  }

  getCompanyPermission(compId: number, userId: number) {
    const url = environment.apiUrl + 'users/' + userId + '/companies/' + compId + '/user-permissions';
    return this.http.get(url, this.httpHelper.httpReadOnlyOptions);
  }

  checkToken(): Observable<UserTokenCheck> {
    const url = environment.apiUrl + 'auth/check-token';
    const res = this.http.get<UserTokenCheck>(url, this.httpHelper.httpOptions);
    return res;
  }
}
